import { useContext } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import Pagination from "../../components/Pagination";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { providerService } from "../../services/providerService";
import Loading from "../../components/common/Loading";
import { toast } from "../../services/toastService";
import { params } from "../../config/params";
import {searchParams} from "../../config/searchParams";
import InLinneLoading from "../../components/common/InlineLoading";

const Providers = () => {
  const { t,lang } = useContext(LocaleContext);
  const [isChecked, setIsChecked] = useState(true);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loadingId, setLoadingId] = useState(null);
  //Provider dashboard
  const [loadingProviderDashboardId, setLoadingProviderDashboardId] = useState(null);
  
   useEffect(() => {
      setLoading(true);
      getAllAsync();
    }, []);
  
    const getAllAsync = async () => {
      try {
        var data = await providerService.getAllAsync(params);
        setData(data);
        console.log(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    const getAllSearchAsync = async (signal) => {
      try {
        var data = await providerService.getAllSearchAsync(searchParams, signal);
        setData(data);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    // 🟢 Search effect with debounce & cancel
    useEffect(() => {
      if (search.trim().length < 2) {
        params.pageNumber = 1;
        getAllAsync(); // reset to default if search is cleared
        return;
      }
  
      const controller = new AbortController(); // cancel token
      const delay = setTimeout(() => {
        searchParams.search = search.trim(); // update global params
        searchParams.pageNumber = 1; // reset page to 1 on search
        getAllSearchAsync(controller.signal);
      }, 400); // debounce time
  
      return () => {
        controller.abort(); // cancel previous request
        clearTimeout(delay); // clear debounce
      };
    }, [search]);
    const onPageChange = async (pageNumber) => {
      setLoading(true);
      if (!search) {
        params.pageNumber = pageNumber;
        getAllAsync();
        return;
      }
      searchParams.pageNumber = pageNumber;
      await getAllSearchAsync();
    };
   
     const handleChecked = async (id) => {
        setLoadingId(id);
        const previousData = data;
    
        try {
          console.log(data);
    
          // ✅ IMPORTANT: use data.items
          const safeItems = Array.isArray(data?.items) ? data.items : [];
    
          const updatedItems = safeItems.map((item) =>
            item.id === id ? { ...item, active: !item.active } : item,
          );
    
          // ✅ keep pagination structure intact
          setData({
            ...data,
            items: updatedItems,
          });
    
          const response = await providerService.toggleActivate(id);
    
          if (!response.isSuccess) {
            setData(previousData);
            response.key
              ? toast.error(t(response.key))
              : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
            return;
          }
    
          toast.success(t("recordUpdatedSuccessfully"));
        } catch (error) {
          setData(previousData);
          toast.error(t("anErrorOccurredPleaseTryAgainLater"));
          console.log(error);
        } finally {
          setLoadingId(null);
        }
      };
      const handleProviderDashboardChecked = async (id) => {
        setLoadingProviderDashboardId(id);
        const previousData = data;
    
        try {
          console.log(data);
    
          // ✅ IMPORTANT: use data.items
          const safeItems = Array.isArray(data?.items) ? data.items : [];
    
          const updatedItems = safeItems.map((item) =>
            item.id === id ? { ...item, isProviderDashboard: !item.isProviderDashboard } : item,
          );
    
          // ✅ keep pagination structure intact
          setData({
            ...data,
            items: updatedItems,
          });
    
          const response = await providerService.toggleProviderDashboard(id);
    
          if (!response.isSuccess) {
            setData(previousData);
            response.key
              ? toast.error(t(response.key))
              : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
              console.log(response);
            return;
          }
    
          toast.success(t("recordUpdatedSuccessfully"));
        } catch (error) {
          setData(previousData);
          toast.error(t("anErrorOccurredPleaseTryAgainLater"));
          console.log(error);
        } finally {
          setLoadingProviderDashboardId(null);
        }
      };
    
  return (
    <>
      {loading && <Loading />}
      <section className="providers">
        <div className="default-heading">
          {t("providersDashboardAndManagement")}
        </div>
        <section className="section-dashboard-cards mb-3 d-none">
          <div className="row">
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("totalUsers")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("onlineUsers")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-primary">
                <div className="d-card-header">{t("client")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-card d-card-dark">
                <div className="d-card-header">{t("totalRevenue")}</div>
                <div className="d-card-body">
                  <div className="d-card-body-1">
                    <span>7,125.70</span>
                    <span>{t("newThisMonth")}: 3</span>
                  </div>
                  <div className="d-card-body-2">
                    <span>52.0%</span>
                    <i className="fas fa-arrow-circle-up"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("providersManagement")}</strong>
              <p>{t("viewAndManageAllServiceProvidersInTheSystem")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-file-excel"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-print"></i>
                  </div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                  <div className="grid-btn">
                    <Link to="/provider-form">
                      <button className="btn-default my-bg-secondary">
                        {t("addNewProvider")}{" "}
                        <i className="fas fa-plus"></i>{" "}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allServiceProviders")}</b>
                <div className="dropdown d-none">
                  <i
                    className="fas fa-filter cursor-pointer"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  />
                  <span></span>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("status")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("category")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("city")}
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="#">
                        <input type="radio" /> {t("date")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <input type="checkbox" />
                      </th>
                      <th>{t("serviceProviderName")}</th>
                      <th>{t("mobileNo")}</th>
                      <th>{t("noOfTrips")}</th>
                      <th>{t("noOfBookings")}</th>
                      <th>{t("city")}</th>
                       <th>{t("allowedDashboard")}</th>
                      <th>{t("status")}</th>
                      <th>{t("totalProfit")}</th>
                      <th>{t("date")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.items &&
                      data.items.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <input type="checkbox" />
                          </td>
                          <td>{item.fullName}</td>
                          <td>{item.mobileNumber}</td>
                          <td>{item.noOfTrips}</td>
                          <td>{item.noOfBookings}</td>
                          <td>{item.city[lang]}</td>
                           <td>
                            {loadingProviderDashboardId === item.id ? (
                              <InLinneLoading color={"text-primary"} />
                            ) : (
                              <div className="form-check form-switch flex-center">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`provider-dashboard-switch-${item.id}`}
                                  checked={item.isProviderDashboard}
                                  onChange={() => handleProviderDashboardChecked(item.id)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`provider-dashboard-switch-${item.id}`}
                                ></label>
                              </div>
                            )}
                          </td>
                          <td>
                            {loadingId === item.id ? (
                              <InLinneLoading color={"text-primary"} />
                            ) : (
                              <div className="form-check form-switch flex-center">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`active-switch-${item.id}`}
                                  checked={item.active}
                                  onChange={() => handleChecked(item.id)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`active-switch-${item.id}`}
                                ></label>
                              </div>
                            )}
                          </td>
                          <td>
                            {item.totalProfit} {t("riyal")}
                          </td>
                          <td>{item.dateJoined?.toDate()}</td>
                          <td>
                            <i
                              class="fas fa-ellipsis-vertical"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            ></i>
                            <ul className="dropdown-menu">
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={`/provider-details/${item.id}`}
                                >
                                  <i className="fas fa-eye text-success"></i>{" "}
                                  {t("view")}
                                </Link>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  href={`/provider-form/${item.id}`}
                                >
                                  <i className="fas fa-edit text-warning"></i>{" "}
                                  {t("edit")}
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    {data?.items?.length === 0 && (
                      <tr>
                        <td colSpan="100%" className="text-center py-3">
                          {t("noResultsFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              {data && (
                <Pagination
                  t={t}
                  pageNumber={data.pageNumber}
                  totalPages={data.totalPages}
                  hasNextPage={data.hasNextPage}
                  hasPreviousPage={data.hasPreviousPage}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Providers;
